import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import { AuthContext } from "../../context/AuthContext";
import Chart from "./Chart";
import CardModal from "./card-modal/CardModal";
import { FaFileContract, FaExclamationTriangle } from "react-icons/fa";
import { IoMdArrowDropright } from "react-icons/io";

const Card = () => {
  const [activeContracts, setActiveContracts] = useState(0);
  const [expiredContracts, setExpiredContracts] = useState(0);
  const [contracts, setContracts] = useState([]);
  const [selectedContracts, setSelectedContracts] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { authState } = useContext(AuthContext);

  useEffect(() => {
    const fetchContracts = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/api/bulk/contracts`,
          {
            headers: {
              "x-auth-token": authState.token,
            },
          }
        );
        const contracts = response.data;
        setContracts(contracts);
        const activeCount = contracts.filter(
          (contract) => contract.status === "Active"
        ).length;
        const expiredCount = contracts.filter(
          (contract) => contract.status === "Expired"
        ).length;
        setActiveContracts(activeCount);
        setExpiredContracts(expiredCount);
      } catch (error) {
        if (error.response) {
          toast.error(`Error: ${error.response.data.message}`);
        } else {
          toast.error("An unexpected error occurred ⛔⛔");
        }
      }
    };

    fetchContracts();
  }, [authState.token]);

  const openModal = (status) => {
    const filteredContracts = contracts.filter((c) => c.status === status);
    setSelectedContracts(filteredContracts);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedContracts([]);
  };

  return (
    <div className="grid w-full md:grid-cols-4 gap-4 ">
      <div className="col-span-4 md:col-span-1 bg-white dark:bg-gray-800 shadow-lg rounded-xl overflow-hidden transition-all duration-300 hover:shadow-xl">
        <div className="flex flex-col p-4">
          <div className="flex items-center mb-2">
            <FaFileContract className="text-blue-500 mr-2" size={20} />
            <span className="font-semibold text-gray-700 dark:text-gray-200">
              Active Contracts
            </span>
          </div>
          <div className="flex items-center justify-between">
            <div className="text-3xl font-bold text-blue-600 dark:text-blue-400">
              {activeContracts}
            </div>
            <button
              className="flex items-center text-sm text-blue-500 hover:text-blue-700 font-medium transition-colors duration-200"
              onClick={() => openModal("Active")}
            >
              See More
              <IoMdArrowDropright className="ml-1" size={18} />
            </button>
          </div>
        </div>
      </div>
      <div className="col-span-4 md:col-span-3 row-span-2 bg-white dark:bg-gray-800 shadow-lg rounded-xl overflow-hidden">
        <Chart />
      </div>
      <div className="col-span-4 md:col-span-1 bg-white dark:bg-gray-800 shadow-lg rounded-xl overflow-hidden transition-all duration-300 hover:shadow-xl">
        <div className="flex flex-col p-4">
          <div className="flex items-center mb-2">
            <FaExclamationTriangle className="text-yellow-500 mr-2" size={20} />
            <span className="font-semibold text-gray-700 dark:text-gray-200">
              Expired Contracts
            </span>
          </div>
          <div className="flex items-center justify-between">
            <div className="text-3xl font-bold text-yellow-600 dark:text-yellow-400">
              {expiredContracts}
            </div>
            <button
              className="flex items-center text-sm text-yellow-500 hover:text-yellow-700 font-medium transition-colors duration-200"
              onClick={() => openModal("Expired")}
            >
              See More
              <IoMdArrowDropright className="ml-1" size={18} />
            </button>
          </div>
        </div>
      </div>

      <CardModal
        isOpen={isModalOpen}
        onClose={closeModal}
        contracts={selectedContracts}
      />
    </div>
  );
};

export default Card;